import { Instance } from "./Base";

export default class LabelElement implements Instance {
  private instance: HTMLLabelElement;

  constructor(name: string, value: string, classes: string[] = []) {
    this.instance = document.createElement("label");
    this.instance.setAttribute("for", name);
    this.instance.innerHTML = value;
    this.instance.classList.add(...classes);
  }

  get element(): HTMLElement {
    return this.instance;
  }
}
